import { render, staticRenderFns } from "./ProjectEditorHeaderCollapseableTab.vue?vue&type=template&id=63ff4251"
import script from "./ProjectEditorHeaderCollapseableTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditorHeaderCollapseableTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectEditorHeaderCollapseableTab.vue?vue&type=style&index=0&id=63ff4251&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports